export enum ACTION_TYPES {
  ApplyPermit = "Apply Permit",
  CancelPermit = "Cancel Application",
  ApplyForChange = "APPLY FOR CHANGE",
  ReplaceVehicle = "REPLACE VEHICLE",
  ChangeRoute = "CHANGE ROUTE",
  DuplicatePermit = "DUPLICATE PERMIT",
  AddPermitType = "ADD PERMIT TYPE",
  Renew = "RENEW",
  ErrorCorrection = "ERROR CORRECTION",
}
export enum ADD_VEHICLE_ACTION_TYPES {
  AddVehicle = "Add Vehicle",
 // Delete = "Delete",
 // UpdateHistory = "Update History",
  UploadDocuments = "Upload Documents",

  // DeletePermit = 'Delete Permit',
  // UnsumitApplication  = 'Unsumit Application',
  //View = "View",
}
export enum CARRIER_ACTION_TYPES {
  ViewAccount = "View Account",
  // EditAccount = 'Edit Account',

  Unsubmit = "Unsubmit",
  AccountStatement = "Account Statement",
  LinkConsultants = "Appoint Consultants",
  ViewOcas = "OCCAS Module",
  OcasAudit = "Ocas Audit",
  AnnualCompliance = "Annual Compliance",
  MonthlyCompliance = "Monthly Compliance",
  FundAccount = "Fund My Account",
  MyCarrierPermits = "My Carrier Permits",
  CarrierReports ="Carrier Reports"

}
export enum CAPERMIT_ACTIONS {
  MyPermits = "My Permits",
  MyApplications = "My Applications",
  DeleteAccount = "Delete Account",
  AnnualCompliance = "Annual Compliance",
}

export enum PERMIT_TYPE_ACTIONS {
  AddPermit = "Add Permit",
  EditPermit = "Edit Permit",
  DeletePermit = "Delete Permit",
}

export enum VEHICLE_TYPE_ACTIONS {
  AddVehicle = "Add Vehicle",
  EditVehicle = "Edit Vehicle",
  DeleteVehicle = "Delete Vehicle",
}

export enum PERMIT_ACTIONS {
  ApplyApplication = "New Application",
  // EditApplication = 'Edit Application',
  // ViewApplication = 'View Application',
  // DeleteApplication = 'Delete Application',
  // UnsumitApplication  = 'Unsumit Application',
  CancelApplication = "Cancel Application",
}

export enum TRANSPORT_ASSOCIATIONS_ACTIONS {
  AddTransport = "Add Transport",
  EditTransport = "Edit Transport",
  DeleteTransport = "Delete Transport",
}
//@
export enum LINK_PERMITS_DOCUMENT_ACTIONS {
  Link = "Link Document",
  Delink = "Delink Document",
}

//@CARRIER_TYPE
export enum CARRIER_TYPE_ACTIONS {
  EditCarrierTypes = "Edit Carrier Types",
  DeleteCarrierTypes = "Delete Carrier Types",
  AddCarrierType = "Add Carrier Type",
}

// CONSTANT EXPORTS

export enum INT_CARRIER_ACCOUNTS {
  ViewAccount = "View Carrier Account",
  ProcessAccount = "Process Carrier Account",
}

export enum INT_PERMIT_APPROVALS {}
// ViewEditPermitApplication = 'View OR Edit Permit Application',
// ProcessPermitApplication = 'Process Permit Application',
// PrintPermit = 'Print Permit',
// ModifyPermit = 'Modify Permit Details'

export const CARRIER_ACTION = [
  {
    value: CARRIER_TYPE_ACTIONS.EditCarrierTypes,
    viewValue: "Edit Carrier",
    icon: "../../../assets/newimg/folder-dublicate-fill@2x.svg",
  },
  {
    value: CARRIER_TYPE_ACTIONS.DeleteCarrierTypes,
    viewValue: "Delete Carrier",
    icon: "../../../assets/newimg/delete@1x.png",
  },
  {
    value: CARRIER_TYPE_ACTIONS.AddCarrierType,
    viewValue: "Add Carrier",
    icon: "../../../assets/newimg/add-circle-4@2x.png",
  },
];

export const DOCUMENT_LINK_DELINK_ACTION = [
  {
    value: LINK_PERMITS_DOCUMENT_ACTIONS.Delink,
    viewValue: "Click To Link",
    icon: "../../../assets/newimg/subtract-1@2x.svg",
  },
  {
    value: LINK_PERMITS_DOCUMENT_ACTIONS.Link,
    viewValue: " Click To De-Link",
    icon: "../../../assets/newimg/link.png",
  },
];

export const ACTIONS = [
  {
    value: ACTION_TYPES.ApplyPermit,
    viewValue: "Apply Permit",
    icon: "../../../assets/newimg/add-circle-4@2x.png",
  },
  //  {
  //   value: ACTION_TYPES.EditPermit,
  //   viewValue: 'Edit Permit',
  //   icon: '../../../assets/newimg/border-color-13@2x.png'
  // },
  // {
  //   value: ACTION_TYPES.ViewPermit,
  //   viewValue: 'View Permit',
  //   icon: '../../../assets/newimg/visibility-2@2x.png',
  // },
  // {
  //   value: ACTION_TYPES.DeletePermit,
  //   viewValue: 'Delete Permit',
  //   icon: '../../../assets/newimg/delete@1x.png',
  // },
  // {
  //   value: ACTION_TYPES.ApplyForChange,
  //   viewValue: "Apply For Change",
  //   icon: "../../../assets/newimg/subtract-1@2x.svg",
  // },
  //below changes effected by https://dev.azure.com/cbrtaicbms/ICBMS/_sprints/taskboard/CrossEasy%20Phase%202/ICBMS/UIX%20Release%2017%20Jul%20-%2031%20Jul%2023?workitem=1326
  {
    value: ACTION_TYPES.ReplaceVehicle,
    viewValue: "Vehicle Replacement",
    icon: "../../../assets/newimg/icon@2x.svg",
  },
  {
    value: ACTION_TYPES.ChangeRoute,
    viewValue: "Route Amendment",
    icon: "../../../assets/newimg/pointers-fill@2x.svg",
  },
  {
    value: ACTION_TYPES.DuplicatePermit,
    viewValue: "Duplicate Permit",
    icon: "../../../assets/newimg/folder-dublicate-fill@2x.svg",
  },
  {
    value: ACTION_TYPES.Renew,
    viewValue: "Permit Renewal",
    icon: "../../../assets/newimg/icon-1@2x.svg",
  },
  {
    value: ACTION_TYPES.ErrorCorrection,
    viewValue: "Error Correction",
    icon: "../../../assets/newimg/subtract-1@2x.svg",
  },
];
//CARRIER ACTIONS
export const CARRIER_ACTIONS = [
  // {
  //   value: CARRIER_ACTION_TYPES.MyPermits,
  //   viewValue: 'My Permits',
  //   icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  // },
  // {
  //   value: CARRIER_ACTION_TYPES.MyApplications,
  //   viewValue: 'My Applications',
  //   icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  // },
  // {
  //   value: CARRIER_ACTION_TYPES.ViewAccount,
  //   viewValue: 'View Account',
  //   icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  // },
  // {
  //   value: CARRIER_ACTION_TYPES.EditAccount,
  //   viewValue: 'Edit Account',
  //   icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  // },
  {
    value: CARRIER_ACTION_TYPES.Unsubmit,
    viewValue: "Unsubmit",
    icon: "../../../assets/newimg/folder-dublicate-fill@2x.svg",
  },
  // {
  //   value: CARRIER_ACTION_TYPES.DeleteAccount,
  //   viewValue: 'Delete Account',
  //   icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  // },
  {
    value: CARRIER_ACTION_TYPES.AccountStatement,
    viewValue: "Account Statement",
    icon: "../../../assets/newimg/folder-dublicate-fill@2x.svg",
  },
  {
    value: CARRIER_ACTION_TYPES.LinkConsultants,
    viewValue: "Appoint Consultants",
    icon: "../../../assets/newimg/folder-dublicate-fill@2x.svg",
  },
  {
    value: CARRIER_ACTION_TYPES.FundAccount,
    viewValue: "Fund My Account",
    icon: "../../../assets/newimg/folder-dublicate-fill@2x.svg",
  },

  // {
  //   value: CARRIER_ACTION_TYPES.ViewOcas,
  //   viewValue: 'OCAS',
  //   icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  // },
  {
    value: CARRIER_ACTION_TYPES.OcasAudit,
    viewValue: 'OCAS Audit',
    icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  },
  {
    value: CARRIER_ACTION_TYPES.MyCarrierPermits,
    viewValue: 'My Permits',
    icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  },
  {
    value: CARRIER_ACTION_TYPES.AnnualCompliance,
    viewValue: 'Annual Compliance',
    icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  },
  {
    value: CARRIER_ACTION_TYPES.MonthlyCompliance,
    viewValue: 'Monthly Compliance',
    icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  },
  {
    value: CARRIER_ACTION_TYPES.CarrierReports,
    viewValue: 'Carrier Reports',
    icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  }
];
export const CARRIER_PERMIT_ACTIONS = [
  // {
  //   value: CAPERMIT_ACTIONS.MyPermits,
  //   viewValue: "My Permits",
  //   icon: "../../../assets/newimg/folder-dublicate-fill@2x.svg",
  // },
  {
    value: CAPERMIT_ACTIONS.MyApplications,
    viewValue: "My Applications",
    icon: "../../../assets/newimg/folder-dublicate-fill@2x.svg",
  },
  // {
  //   value: CAPERMIT_ACTIONS.AnnualCompliance,
  //   viewValue: 'Annual Compliance',
  //   icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  // }
];
export const VEHICLE_ACTION_TYPES = [
  {
    value: ADD_VEHICLE_ACTION_TYPES.AddVehicle,
    viewValue: "Add Vehicle",
    icon: "../../../assets/newimg/icon@2x.svg",
  },
  //  {
  //    value: ADD_VEHICLE_ACTION_TYPES.Delete,
  //    viewValue: "Delete",
  //    icon: "../../../assets/newimg/delete@1x.png",
  //  },
  {
    value: ADD_VEHICLE_ACTION_TYPES.UploadDocuments,
    viewValue: "Upload Documents",
    icon: "../../../assets/newimg/folder-dublicate-fill@2x.svg",
  },
  // {
  //   value: ADD_VEHICLE_ACTION_TYPES.UpdateHistory,
  //   viewValue: "Update History",
  //   icon: "../../../assets/newimg/border-color-13@2x.png",
  // },
  // {
  //   value: ADD_VEHICLE_ACTION_TYPES.View,
  //   viewValue: "View",
  //   icon: "../../../assets/newimg/visibility-2@2x.png",
  // },
  // {

  //   value: CAPERMIT_ACTIONS.AnnualCompliance,
  //   viewValue: 'Annual Compliance',
  //   icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  // }
];

export const INT_CARRIER_ACCOUNTS_ACTIONS = [
  {
    value: INT_CARRIER_ACCOUNTS.ViewAccount,
    viewValue: "Edit Carrier Account",
    icon: "../../../assets/newimg/folder-dublicate-fill@2x.svg",
  },
  {
    value: INT_CARRIER_ACCOUNTS.ProcessAccount,
    viewValue: "Proccess Carrier Account",
    icon: "../../../assets/newimg/folder-dublicate-fill@2x.svg",
  },
];

export const INT_PERMIT_TYPE_ACTIONS = [
  {
    value: PERMIT_TYPE_ACTIONS.EditPermit,
    viewValue: "Edit Permit Type",
    icon: "../../../assets/newimg/border-color-13@2x.png",
  },
  {
    value: PERMIT_TYPE_ACTIONS.DeletePermit,
    viewValue: "Delete Permit Type",
    icon: "../../../assets/newimg/delete@1x.png",
  },
  {
    value: PERMIT_TYPE_ACTIONS.AddPermit,
    viewValue: "Add Permit Type",
    icon: "../../../assets/newimg/add-circle-4@2x.png",
  },
];

export const INT_VEHICLE_TYPE_ACTIONS = [
  {
    value: VEHICLE_TYPE_ACTIONS.EditVehicle,
    viewValue: "Edit Vehicle Type",
    icon: "../../../assets/newimg/border-color-13@2x.png",
  },
  {
    value: VEHICLE_TYPE_ACTIONS.DeleteVehicle,
    viewValue: "Delete Vehicle Type",
    icon: "../../../assets/newimg/delete@1x.png",
  },
  {
    value: VEHICLE_TYPE_ACTIONS.AddVehicle,
    viewValue: "Add Vehicle Type",
    icon: "../../../assets/newimg/add-circle-4@2x.png",
  },
];

export const INT_PERMIT_APPROVALS_ACTIONS = [
  // {
  //   value: INT_PERMIT_APPROVALS.ViewEditPermitApplication,
  //   viewValue: 'View/Edit Permit Application',
  //   icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  // },
  // {
  //   value: INT_PERMIT_APPROVALS.ProcessPermitApplication,
  //   viewValue: 'Process Permit Application',
  //   icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  // // },
  // {
  //   value: INT_PERMIT_APPROVALS.ModifyPermit,
  //   viewValue: 'Modify Permit Details',
  //   icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  // },
  // {
  //   value: INT_PERMIT_APPROVALS.PrintPermit,
  //   viewValue: 'Print Permit',
  //   icon: '../../../assets/newimg/folder-dublicate-fill@2x.svg',
  // }
];
export const PERMIT_FIRST_ACTIONS = [
  {
    value: PERMIT_ACTIONS.ApplyApplication,
    viewValue: "New Application",
    icon: "../../../assets/newimg/add-circle-4@2x.png",
  },
  //{
  //   value: PERMIT_ACTIONS.EditApplication,
  //   viewValue: 'Edit Application',
  //   icon: '../../../assets/newimg/border-color-13@2x.png'
  // },
  // {
  //   value: PERMIT_ACTIONS.ViewApplication,
  //   viewValue: 'View Application',
  //   icon: '../../../assets/newimg/visibility-2@2x.png',
  // },
  // {
  //   value: PERMIT_ACTIONS.DeleteApplication,
  //   viewValue: 'Delete Application',
  //   icon: '../../../assets/newimg/delete@1x.png',
  // },
  {
    value: PERMIT_ACTIONS.CancelApplication,
    viewValue: "Cancel Application",
    icon: "../../../assets/newimg/close-6@2x.png",
  },
];

export const TRANSPORT_ASSOCIATIONS = [
  {
    value: TRANSPORT_ASSOCIATIONS_ACTIONS.EditTransport,
    viewValue: "Edit Transport",
    icon: "../../../assets/newimg/border-color-13@2x.png",
  },
  {
    value: TRANSPORT_ASSOCIATIONS_ACTIONS.DeleteTransport,
    viewValue: "Delete Transport",
    // icon: '../../../assets/newimg/visibility-2@2x.png',
    icon: "../../../assets/newimg/delete@1x.png",
  },
  {
    value: TRANSPORT_ASSOCIATIONS_ACTIONS.AddTransport,
    viewValue: "Add Transport",
    icon: "../../../assets/newimg/add-circle-4@2x.png",
  },
];

export enum WFSTATUS_TYPE_ACTIONS {
  AddWFStatus = "Add Status",
  EditWFStatus = "Edit Status",
  DeleteWFStatus = "Delete Status",
}

export const INT_WFSTATUS_TYPE_ACTIONS = [
  {
    value: WFSTATUS_TYPE_ACTIONS.EditWFStatus,
    viewValue: "Edit Status",
    icon: "../../../assets/newimg/border-color-13@2x.png",
  },
  {
    value: WFSTATUS_TYPE_ACTIONS.DeleteWFStatus,
    viewValue: "Delete Status",
    icon: "../../../assets/newimg/delete@1x.png",
  },
  {
    value: WFSTATUS_TYPE_ACTIONS.AddWFStatus,
    viewValue: "Add Status",
    icon: "../../../assets/newimg/add-circle-4@2x.png",
  },
];

export enum WFACTION_TYPE_ACTIONS {
  AddWFAction = "Add Action",
  EditWFAction = "Edit Action",
  DeleteWFAction = "Delete Action",
}

export const INT_WFACTION_TYPE_ACTIONS = [
  {
    value: WFACTION_TYPE_ACTIONS.EditWFAction,
    viewValue: "Edit Action",
    icon: "../../../assets/newimg/border-color-13@2x.png",
  },
  {
    value: WFACTION_TYPE_ACTIONS.DeleteWFAction,
    viewValue: "Delete Action",
    icon: "../../../assets/newimg/delete@1x.png",
  },
  {
    value: WFACTION_TYPE_ACTIONS.AddWFAction,
    viewValue: "Add Action",
    icon: "../../../assets/newimg/add-circle-4@2x.png",
  },
];

export enum WFROUTETYPE_TYPE_ACTIONS {
  AddWFRouteType = "Add RouteType",
  EditWFRouteType = "Edit RouteType",
  DeleteWFRouteType = "Delete RouteType",
}

export enum WFROUTES_ACTIONS {
  AddWFRoute = "Manage Action",
  EditWFRoute = "Edit Action",
  DeleteWFRoute = "Delete Action",
}

export enum WFDELEGATION {
  AddWFDelegation = "Manage Delegation",
  EditWFDelegation = "Edit Delegation",
  DeleteWFDelegation = "Delete Delegation",
}

export enum WFINBOX {
  ViewUnassigned = "View Unassigned"
}

export enum WFMANAGE {
  ViewUnassigned = "View Unassigned",
  ReassignSelected = "Reassign Activity"
}

export const INT_WFROUTES_ACTIONS = [
  {
    value: WFROUTES_ACTIONS.EditWFRoute,
    viewValue: "Edit Process",
    icon: "../../../assets/newimg/border-color-13@2x.png",
  },
  {
    value: WFROUTES_ACTIONS.DeleteWFRoute,
    viewValue: "Delete Process",
    icon: "../../../assets/newimg/delete@1x.png",
  },
  {
    value: WFROUTES_ACTIONS.AddWFRoute,
    viewValue: "Add Process",
    icon: "../../../assets/newimg/add-circle-4@2x.png",
  },
];

export const INT_WFROUTETYPE_TYPE_ACTIONS = [
  {
    value: WFROUTETYPE_TYPE_ACTIONS.EditWFRouteType,
    viewValue: "Edit RouteType",
    icon: "../../../assets/newimg/border-color-13@2x.png",
  },
  {
    value: WFROUTETYPE_TYPE_ACTIONS.DeleteWFRouteType,
    viewValue: "Delete RouteType",
    icon: "../../../assets/newimg/delete@1x.png",
  },
  {
    value: WFROUTETYPE_TYPE_ACTIONS.AddWFRouteType,
    viewValue: "Add RouteType",
    icon: "../../../assets/newimg/add-circle-4@2x.png",
  },
];

export const INT_WFDELEGATIONS = [
  {
    value: WFDELEGATION.EditWFDelegation,
    viewValue: "Edit Delegation",
    icon: "../../../assets/newimg/border-color-13@2x.png",
  },
  {
    value: WFDELEGATION.DeleteWFDelegation,
    viewValue: "Delete Delegation",
    icon: "../../../assets/newimg/delete@1x.png",
  },
  {
    value: WFDELEGATION.AddWFDelegation,
    viewValue: "Add Delegation",
    icon: "../../../assets/newimg/add-circle-4@2x.png",
  },
];

export const INT_WFINBOX_ACTIONS = [
  {
    value: WFINBOX.ViewUnassigned,
    viewValue: "View Unassigned",
    icon: "../../../assets/newimg/visibility-16@2x.png",
  },

]

export const INT_WFMANAGE_ACTIONS = [
/*   {
    value: WFMANAGE.ViewUnassigned,
    viewValue: "View Unassigned",
    icon: "../../../assets/newimg/visibility-16@2x.png",
  }, */
  {
    value: WFMANAGE.ReassignSelected,
    viewValue: "Reassign Selected",
    icon: "../../../assets/newimg/border-color-13@2x.png",
  }
];